import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../i18n/LangContext";

export const ShareButton = ({ className = "", testId = "share-button" }) => {
    const { t } = useLang();

    const share = async () => {
        const url = window.location.href;
        if (navigator.share) {
            try {
                await navigator.share({ title: "Yasmim Nails", text: t.share.text, url });
            } catch {
                /* partilha cancelada */
            }
        } else {
            try {
                await navigator.clipboard.writeText(url);
                toast.success(t.share.copied);
            } catch {
                /* clipboard indisponível */
            }
        }
    };

    return (
        <button
            data-testid={testId}
            onClick={share}
            aria-label="Compartilhar site"
            className={className}
        >
            <Share2 className="h-4 w-4" />
        </button>
    );
};
